import { Backbone } from "extensions/backbone";
import { _ } from "extensions/underscore";
import { captureException } from "extensions/sentry";

import { getBySubtype } from "./dataTypes/_all";
import { widgetReferences } from "./references";

const WidgetSubtypeModel = Backbone.Model.extend({
    defaults: () => ({
        api_endpoint: "",
        quick: {
            summaryTemplate: "summary1",
            chart: {
                type: "",
                series: []
            }
        }
    }),
    
    getClone() {
        return _.clone(this.get.apply(this, arguments));
    }
});

export const DefaultModel = Backbone.Model.extend({
    isCustom: false,
    defaults: () => ({
        x: 0,
        y: 0,
        w: 2,
        h: 2,
        title: "",
        widgetType: "default",
        widgetSubtype: "",
        options: {}
    }),
    
    initialize() {
        const widgetSubtype = this.get("widgetSubtype");
        
        // If widget comes with a reference we should resolve it to a widget structure and mutate opts
        if (this.getOption("widgetReference")) {
            const resolvedReference = _.propValue(widgetReferences, this.getOption("widgetReference"));
            if (resolvedReference) {
                // Mutate opts here
                this.set({
                    options: _.deepExtend(_.clone(this.get("options")), resolvedReference)
                });
            } else {
                captureException(new Error("Widget reference doesn't exist"));
            }
        }
        
        // Read-only subtype model
        if (!this.isCustom) {
            this.subtypeModel = new WidgetSubtypeModel(getBySubtype(widgetSubtype, this.get("options")));
        }
    },
    
    changeChartType(chart) {
        this.set("widgetType", chart);
    },
    getOption(opt) {
        const options = _.clone(this.get("options"));
        return options[opt];
    },
    
    isTable() {
        return this.get("widgetType") === "table";
    },
    
    getModelData() {
        const data = this.toJSON();
        
        delete data.auto;
        
        // If widget was created by reference, then remove everything except the actual reference to prevent storing reference
        // definitions in the db
        if (data.options && data.options.widgetReference) {
            data.options = {
                widgetReference: data.options.widgetReference
            };
        }
        
        return data;
    }
});
